import {FETCH_EXPERIENCE_REQUEST, FETCH_EXPERIENCE_SUCCES, FETCH_EXPERIENCE_ERROR} from '../constants/Experience'

const initialState = {
  list: [],
  hasErrored: false,
  isLoading: false
}

export default function experience(state = initialState, action) {
  switch (action.type) {
      case FETCH_EXPERIENCE_REQUEST:
        return {...state, isLoading: true};
      case FETCH_EXPERIENCE_SUCCES:
        return {...state, list: action.payload.results, isLoading: false};
      case FETCH_EXPERIENCE_ERROR:
        return {...state, hasErrored: true, isLoading: false};
      default:
          return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/experience.js